<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl ? `transaction/student-group/${inputs.id}` : `transaction/student-group`
				"
			>
				<div class="form-group row align-items-center">
					<label class="col-sm-6 mb-0">
						<h4>Edit Student</h4>
					</label>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_clc_id_number" class="col-sm-3 mb-0">
						CLC ID Number
					</label>
					<app-input
						id="inputs_clc_id_number"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_clc_id_number"
						@input="setClcIdNumber"
						:fetch-url="'transaction/lead?clc_id_number_operator=!=&clc_id_number=null'"
						placeholder="CLC ID Number"
						list-value-field="clc_id_number"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_first_name" class="col-sm-3 mb-0">
						First Name
					</label>
					<app-input
						id="inputs_first_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.first_name"
						placeholder="First Name"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_last_name" class="col-sm-3 mb-0">
						Last Name
					</label>
					<app-input
						id="inputs_last_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.last_name"
						placeholder="Last Name"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_action" class="col-sm-3 mb-0">
						Action
					</label>
					<app-input
						id="inputs_action"
						class="col-sm-9"
						type="search-select"
						:list="actionIdLists"
						v-model="inputs.action"
						placeholder="Action"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_reason" class="col-sm-3 mb-0">
						Reason
					</label>
					<app-input
						id="inputs_reason"
						class="col-sm-9"
						type="textarea"
						v-model="inputs.reason"
						placeholder="Reason"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_last_modified" class="col-sm-3 mb-0">
						Last Modified
					</label>
					<app-input
						id="inputs_last_modified"
						class="col-sm-9"
						type="date"
						v-model="inputs.updated_at"
						placeholder="Last Modified"
						:disabled="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label class="col-sm-6 mb-0">
						<h4>Assigned To</h4>
					</label>
				</div>
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_course_id" class="col-sm-3 mb-0">
						Class Name
					</label>
					<app-input
						id="inputs_course_id"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_course_id"
						@input="setCourseIdValue"
						fetch-url="transaction/course"
						class="col-sm-9"
						placeholder="Class Name"
						list-value-field="course_name"
						required
					/>
				</div> -->

				<div class="form-group row align-items-center">
					<label for="inputs_main_teacher_id" class="col-sm-3 mb-0">
						Main Teacher
					</label>
					<app-input
						id="inputs_main_teacher_id"
						class="col-sm-9"
						type="search-select"
						:list="teachIdLists"
						v-model="inputs.main_teacher_id"
						:placeholder="'Main Teacher'"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_student_care_id" class="col-sm-3 mb-0">
						Student Care
					</label>
					<app-input
						id="inputs_student_care_id"
						class="col-sm-9"
						type="search-select"
						:list="studentCareIdLists"
						v-model="inputs.student_care_id"
						:placeholder="'Student Care'"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_start_date" class="col-sm-3 mb-0">
						Start Date
					</label>
					<app-input
						id="inputs_start_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.start_date"
						:placeholder="'Start Date'"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_end_date" class="col-sm-3 mb-0">
						End Date
					</label>
					<app-input
						id="inputs_end_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.end_date"
						:placeholder="'End Date'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_start_week" class="col-sm-3 mb-0">
						Start Week
					</label>
					<app-input
						id="inputs_start_week"
						class="col-sm-9"
						type="text"
						v-model="inputs.start_week"
						:placeholder="'Start Week'"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_end_week" class="col-sm-3 mb-0">
						End Week
					</label>
					<app-input
						id="inputs_end_week"
						class="col-sm-9"
						type="text"
						v-model="inputs.end_week"
						:placeholder="'End Week'"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "StudentInGroupForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			modalId: this.formId,
			modalTitle: this.$t("add"),
			academyGroupId: null,
			input_clc_id_number: this.value
				? this.value.lead
					? {
							id: this.value.lead.id || 0,
							clc_id_number: this.value.lead.clc_id_number || "", 
							full_name: this.value.lead.full_name || "",
					  }
					: {
							id: this.value.lead?.id || 0,
							clc_id_number: this.value.lead?.clc_id_number || "", 
							full_name: this.value.lead?.full_name || "",
					  }
				: {
						id: this.value.lead.id || 0,
						clc_id_number: this.value.lead.clc_id_number || "",
						full_name: this.value.lead.full_name || "",
				  },
			actionIdLists: [
				{
					id: 1,
					value: "Move Student from Group",
				},
				{
					id: 2,
					value: "Delete from Group",
				},
			],
			// input_course_id: this.value
			// 	? this.value.course
			// 		? {
			// 				id: this.value.course.id || 0,
			// 				course_name: this.value.course.course_name || "",
			// 				is_active: this.value.course.is_active,
			// 		  }
			// 		: {
			// 				id: this.value.course?.id || 0,
			// 				course_name: this.value.course?.course_name || "",
			// 				is_active: this.value.course?.is_active,
			// 		  }
			// 	: {
			// 			id: this.value.course.id || 0,
			// 			course_name: this.value.course.course_name || "",
			// 			is_active: this.value.course.is_active,
			// 	  },
			studentCareIdLists: [],
			teachIdLists: [],
		};
	},
	created() {

		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}

		let url = window.location.href;
		this.academyGroupId = parseInt(url.split("/").slice(-1)[0].split("?")[0]);

		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				if (this.selectedUrl) {
					this.modalTitle = this.$t("edit");
					this.preloader = true;
				}

				let [userResponse] = await Promise.all([
					axios.get("/user-list?per_page=50"),
				]);

				userResponse.data.data.forEach((item) => {
					this.studentCareIdLists.push({
						id: item.id,
						value: item.full_name,
					});

					this.teachIdLists.push({
						id: item.id,
						value: item.full_name,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
  			this.inputs.academic_group_id = this.academyGroupId;
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
            $('#'+this.modalId).modal('hide');
		},

		afterSuccessFromGetEditData(response) {
			this.input_clc_id_number = {
				id: response.data.student_info.id || 0,
				clc_id_number: response.data.clc_id_number || "", 
				full_name: response.data.student_info.full_name || "",
			};
			this.inputs = response.data;
			this.inputs.first_name = response.data.student_info.name ?? "first name not exist";
			this.inputs.last_name = response.data.student_info.surname ?? "last name not exist";
			this.preloader = false;
		},
		setClcIdNumber(data) {
			this.inputs.clc_id_number = this.inputs.clc_id_number;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.clc_id_number = data.clc_id_number;
				this.inputs.first_name = data.name ?? "first name not exist";
				this.inputs.last_name = data.surname ?? "last name not exist";
			}
		},
		// setCourseIdValue(data) {
		// 	this.inputs.course_id = data.id;
		// 	if (data && data.hasOwnProperty("id")) {
		// 		this.inputs.course_id = data.id;
		// 	}
		// },
	},
};
</script>
